




































































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  RedCapital,
  SelectedCountry,
  TitleTemplatePublic,
  Configuration
} from "@/configuration";
import { EventBus } from "@/main";
import API from "@/api";
import axios from "axios";
import { isRutValid, DniTrim } from "@/utils";
import DniPersona from "@/components/DniFieldLanding.vue";
import DniField from "@/components/DniField.vue";
import { isNumberToken } from "html2canvas/dist/types/css/syntax/parser";
//@ts-ignore
import gRecaptcha from '@finpo/vue2-recaptcha-invisible';
import ReCaptcha from "@/components/ReCaptcha.vue";


@Component({
  metaInfo() {
    return {
      title: "Factoring",
      titleTemplate: TitleTemplatePublic,
      htmlAttrs: {
        // @ts-ignore
        lang: RedCapital[SelectedCountry].Lang        
      }
    };
  },
  data() {
    return {
      loading: false,
      aceptar: true,
      RedCapital,
      SelectedCountry,
      validtop: true,
      validtop2: true,
      dialog: false,
      canPress: true,
      showPassword: false,
      terms: true,
      tokenn:'',
      nombres:"",
      user: {
        name: "",
        lastname: "",
        email: "",
        password: "",
        c_password: "",
        dni: "",
        phone: "",
        type: 3,
        via_id: 1,
      },
      btn: {
        clickable: false,
        loading: false,
        isOk: null,
        successText: "Guardado correctamente",
        errorText: "Error interno",
      },
      
      landing: "Factoring",
      rules: {
        nombres: [
          (v: any) => !!v || "Ingrese su nombre y apellido",
          (v: any) => /[A-Za-z]/.test(v) || "Ingrese su nombre y apellido", 
          (v: any) => /..+ +../.test(v) || "Ingrese su nombre y apellido",
          (v: any) =>
            v.length <= 255 || "Nombre no puede exceder los 255 caracteres."
        ],
        email: [
          (v: any) => !!v || "Ingrese correo electrónico",
          (v: any) => /.+@.+/.test(v) || "La dirección debe ser válida"
        ],
        ruc: [
          // @ts-ignore
          (v: any) => !!v || `${RedCapital[SelectedCountry].DniName} es requerido`,
          // @ts-ignore
          (v: any) => v.toString().length != 11 || `${RedCapital[SelectedCountry].DniName} no válido`,
        ],
        rut: [
          (v: any) =>
            // @ts-ignore
            !!v || `${RedCapital[SelectedCountry].DniName} es requerido`,
          (v: any) =>
            /^(\d{1,3}(?:\.\d{1,3}){2}-[\dkK])$/.test(v) ||
            // @ts-ignore
            `${RedCapital[SelectedCountry].DniName} invalido Ej: 12.345.678-9`
        ],
        password:[
          (v: any) => !!v || "Ingrese su contraseña",
          (v: any) =>
            v.length >= 4 || "Su contraseña debe contener al menos 4 caracteres."
        ]
      }
    }
    
  },
  methods: {
      enviar(){
        this.$data.loading=true;
        setTimeout(() => {
        this.$data.loading=false,
        this.$data.aceptar=!this.$data.aceptar},3000);
      },
      async validateTop(response) {
      let aux;
      aux=this.$data.nombres.split(" ");
      this.$data.user.name= aux[0];
      this.$data.user.lastname= aux[1];
      this.$data.loading = true;
      this.$data.canPress = false;
      API.landing
        .factoring(
          this.$data.user.name,
          this.$data.user.lastname,
          this.$data.user.dni,
          this.$data.user.email,
          this.$data.landing,
          this.$data.user.via_id,
        )
        .then((data: any) => {
          setTimeout(() => {
          this.$data.loading=false,
          this.$data.aceptar=!this.$data.aceptar},3000);
        })
        .catch((error: any) => {
          this.$data.loading = false;
          this.$data.canPress = true;
          this.$data.error = "Error";
          if (error.message.nombre != null) {
            EventBus.$emit("snack-error", error.message.nombre[0]);
          }
          if (error.message.mail != null) {
            EventBus.$emit("snack-error", error.message.mail[0]);
          }
        });
      },
      validatee() {
        // validate your form , if you don't have validate prop , default validate pass .
        return true;
      },
      callback(token) {
        // google recaptcha token , then you can pass to backend with your form data .
        if (token) {
          this.$data.tokenn = token
          //@ts-ignore
          this.onSubmit(token)
        }else{
          // if you use data-size show reCAPTCHA , maybe you will get empty token.
        // alert('please check you are not robot');
          this.$data.canPress = true;
          this.$data.errorMessage = "Error";
        }
      },

      async onSubmit(token) {
        this.$data.errors = []
        // @ts-ignore.
        if (this.$refs.form.validate()) {
          this.$data.btn.loading = true
          this.$data.errorMessage = []

          this.$data.user.c_password = this.$data.user.password
          var n = this.$data.nombres.split(' ')
          var name,lastname
          if(n.length > 1){
            name = n[0];
            let newN = n.splice(0,1);
            lastname = n.join(' ')
          API.register(token,name, lastname, this.$data.user.email, this.$data.user.password, this.$data.user.c_password, DniTrim.string(this.$data.user.dni), this.$data.user.via_id,this.$data.user.phone, this.$data.user.type).then( (res: any) => {
            if (res.status != 200) {
              this.$data.btn.isOk = false
              if (res.message) {
                EventBus.$emit('snack-error', res.message)
                this.$data.errorMessage.push(res.message)
              }
            } else {
              this.$data.btn.isOk = true
              this.$data.dialog = true
              setTimeout(() => {
                API.login(this.$data.user.dni, this.$data.user.password).then((data: any) => {
                  this.$store.commit('setUser', data.usuario)
                  this.$store.commit('setToken', data.access_token)
                  this.$store.commit('setExpireTime', data.expires_at)
                  this.$store.commit("setMenu", data.usuario.user_tipo_id);
                  
                  this.$router.push({
                    path: '/panel-facto/estadisticas'
                  })
                }).catch((error) => {
                    if(error && error.status === 401){
                      this.$router.push({ path: '/block-account' });
                    }
                });
              }, Configuration.Redirection.timeout)
            }
          }).catch( (error: any) => {
            this.$data.btn.isOk = false
            this.$data.errorMessage.push("Intente nuevamente")
            EventBus.$emit('snack-error', error.message)
                      if(this.$data.user.type == 2){
                        setTimeout(() => {
                          //@ts-ignore
                        this.$router.go();
                      }, Configuration.Redirection.timeout)
                      } 
                      else if(this.$data.user.type) {
                        // @ts-ignore
                      this.business()
                      }
                    })
        }else{
            this.$data.errors.push('Falta Registrar su Apellido')
            this.$data.btn.loading = false
            this.$data.errorMessage = []
          }
        }
      },
      doRecaptcha() {
      // @ts-ignore
      this.$refs.recaptchaRegister.execute();
    },
  },
    
  
  components: {
    DniPersona,
    DniField,
    gRecaptcha,
    ReCaptcha
  } 
})
export default class Landing extends Vue {}
